<template>
  <v-dialog v-model="dialog" persistent scrollable max-width="800px">
    <v-card flat>
      <v-card-title class="pa-0">
        <v-toolbar :color="mode === 'info' ? 'primary' : mode === 'setuju' ? 'green' : 'orange'" dark flat>
          <v-toolbar-title>
            {{
              mode === 'info'
                ? 'Rekap Perubahan Data'
                : mode === 'konfirmasi'
                ? 'Konfirmasi Kirim Perubahan Data'
                : 'Konfirmasi Verval Perubahan Data'
            }}
          </v-toolbar-title>
          <v-spacer />
          <v-btn text icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text v-if="mode === 'konfirmasi'" class="pa-4 px-6">
        <div class="black--text" style="font-size: 17px">
          Berikut rekap perubahan data yang telah Anda lakukan. Apakah Anda yakin ingin
          <span class="font-weight-medium">mengirimkan</span> perubahan data Anda sekarang ?
        </div>
      </v-card-text>
      <v-card-text v-if="mode === 'setuju'" class="pa-4 px-6">
        <div class="black--text" style="font-size: 17px">
          Berikut rekap perubahan data yang telah dilakukan oleh FSP. Apakah Anda yakin ingin
          <span class="font-weight-medium green--text">menyetujui</span> ajuan perubahan data ?
        </div>
      </v-card-text>
      <v-card-text v-if="mode === 'tolak'" class="pa-4 px-6">
        <div class="black--text" style="font-size: 17px">
          Berikut rekap perubahan data yang telah dilakukan oleh FSP. Apakah Anda yakin ingin
          <span class="font-weight-medium orange--text">tolak perbaikan</span> ajuan perubahan data ?
        </div>
      </v-card-text>
      <v-divider />
      <v-card-text>
        <div style="min-height: 100px; max-height: 350px" class="ma-3 mt-5">
          <div v-for="(rekap, i) in rekaps" :key="i">
            <div v-if="rekap.items.length" class="mb-8 pb-6">
              <v-row class="mb-2">
                <v-col cols="12">
                  <h2 class="info--text">{{ rekap.judul }}</h2>
                </v-col>
              </v-row>
              <v-row class="grey lighten-3 hidden-md-and-down">
                <v-col cols="12" lg="4">Jenis Data</v-col>
                <v-col cols="12" lg="4">Data Lama</v-col>
                <v-col cols="12" lg="4">Data Baru</v-col>
              </v-row>
              <v-row v-for="(item, i) in rekap.items" :key="i" class="mt-3">
                <v-col cols="12" lg="4" class="indigo--text">{{ item.label }}</v-col>
                <v-col cols="12" lg="4">
                  <div v-if="item.lama" v-html="item.lama"></div>
                  <div v-else>
                    <div v-if="item.file_lama">
                      <v-btn
                        :href="item.url_lama"
                        :disabled="!item.url_lama"
                        target="_blank"
                        class="text-capitalize blue white--text"
                        small
                        depressed
                      >
                        <v-icon class="mr-2">mdi-eye</v-icon> Lihat Berkas
                      </v-btn>
                    </div>
                    <div v-else>-</div>
                  </div>
                </v-col>
                <v-col cols="12" lg="4">
                  <v-row no-gutters>
                    <v-col style="min-width: 25px; max-width: 100%" class="flex-grow-0 flex-shrink-0 mr-2">
                      <v-icon left color="orange">mdi-arrow-right</v-icon>
                    </v-col>
                    <v-col style="max-width: 100%" :class="['flex-grow-1 flex-shrink-0 text-justify']">
                      <div v-if="item.baru">
                        <strong v-html="item.baru"></strong>
                      </div>
                      <div v-else>
                        <div v-if="item.file_baru">
                          <v-btn
                            :href="item.url_baru"
                            :disabled="!item.url_baru"
                            target="_blank"
                            class="text-capitalize orange white--text"
                            small
                            depressed
                          >
                            <v-icon class="mr-2">mdi-eye</v-icon> Lihat Berkas
                          </v-btn>
                        </div>
                        <div v-else>-</div>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-divider />
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions class="my-1">
        <v-spacer />
        <v-btn text class="grey--text" @click="dialog = false">{{ mode === 'info' ? 'Tutup' : 'Batal' }}</v-btn>
        <v-btn v-if="mode === 'konfirmasi'" depressed dark class="orange" @click="approve">Kirim</v-btn>
        <v-btn
          v-else-if="['setuju', 'tolak'].includes(mode)"
          depressed
          dark
          :class="mode === 'setuju' ? 'green' : 'orange'"
          @click="approve"
        >
          Ya
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    edit: {
      type: Object,
      default: () => {},
    },
    biodata: {
      type: Object,
      default: () => {},
    },
    biodataEdit: {
      type: Object,
      default: () => {},
    },
    keyBiodataUpdates: {
      type: Array,
      default: () => [],
    },
    keyBerkasUpdates: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialog: false,
      mode: 'info',
      mBedaInstansi: {
        51001: 'Ya',
        51002: 'Tidak',
        51003: 'Tidak memiliki Instansi',
      },
      mBedaTugas: {
        51001: 'Tidak',
        51002: 'Ya',
        51003: 'Tidak memiliki Instansi',
      },
    };
  },
  computed: {
    tugasEdit() {
      return this.edit.tugas_edit || {};
    },

    aktifs() {
      return (this.$getDeepObj(this.biodata, 'psp_biodata_tugases') || [])
        .filter((tugas) => tugas.status_gelombang === 'aktif')
        .map((t) => {
          return `${t.jml_pendampingan || 0} ${this.$getDeepObj(t, 'm_jenjang.singkat')}`;
        });
    },

    aktifsEdit() {
      return (this.$getDeepObj(this.biodataEdit, 'psp_biodata_tugases') || [])
        .filter((tugas) => tugas.status_gelombang === 'aktif')
        .map((t) => {
          return `${t.jml_pendampingan || 0} ${this.$getDeepObj(t, 'm_jenjang.singkat')}`;
        });
    },

    lamas() {
      return (this.$getDeepObj(this.biodata, 'psp_biodata_tugases') || [])
        .filter((tugas) => tugas.status_gelombang === 'selesai')
        .map((t) => {
          return `${this.$getDeepObj(t, 'm_jenjang.singkat')}`;
        });
    },

    lamasEdit() {
      return (this.$getDeepObj(this.biodataEdit, 'psp_biodata_tugases') || [])
        .filter((tugas) => tugas.status_gelombang === 'selesai')
        .map((t) => {
          return `${this.$getDeepObj(t, 'm_jenjang.singkat')}`;
        });
    },

    rencanas() {
      return (this.$getDeepObj(this.biodata, 'psp_biodata_tugases') || [])
        .filter((tugas) => tugas.status_gelombang === 'rencana')
        .sort((a, b) => a.prioritas - b.prioritas)
        .map((t, id) => {
          return `${id + 1}. ${this.$getDeepObj(t, 'm_jenjang.singkat')}`;
        });
    },

    rencanasEdit() {
      return (this.$getDeepObj(this.biodataEdit, 'psp_biodata_tugases') || [])
        .filter((tugas) => tugas.status_gelombang === 'rencana')
        .sort((a, b) => a.prioritas - b.prioritas)
        .map((t, id) => {
          return `${id + 1}. ${this.$getDeepObj(t, 'm_jenjang.singkat')}`;
        });
    },

    berkases() {
      let berkas = this.$getDeepObj(this.biodata, 'psp_biodata_berkases') || [];
      let result = {};

      for (const b of berkas) {
        result[this.$getDeepObj(b, 'm_profil_berkas_psp.singkat')] = {
          id: b.psp_biodata_berkas_id || '',
          file: b.file_berkas || '',
          url: b.url_berkas || '',
        };
      }

      return result;
    },

    berkasesEdit() {
      let berkas = this.$getDeepObj(this.biodataEdit, 'psp_biodata_berkases') || [];
      let result = {};

      for (const b of berkas) {
        result[this.$getDeepObj(b, 'm_profil_berkas_psp.singkat')] = {
          id: b.psp_biodata_berkas_id || '',
          file: b.file_berkas || '',
          url: b.url_berkas || '',
        };
      }

      return result;
    },

    profilBiodata() {
      const items = [
        {
          label: 'Alamat (sesuai KTP)',
          lama: this.biodata.alamat_ktp || '-',
          baru: this.biodataEdit.alamat_ktp || '-',
          update: this.keyBiodataUpdates.includes('alamat_ktp'),
        },
        {
          label: 'Provinsi (sesuai KTP)',
          lama: this.$getDeepObj(this.biodata, 'm_propinsi_ktp.keterangan') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'm_propinsi_ktp.keterangan') || '-',
          update: this.keyBiodataUpdates.includes('k_propinsi_ktp'),
        },
        {
          label: 'Kabupaten/Kota (sesuai KTP)',
          lama: this.$getDeepObj(this.biodata, 'm_kota_ktp.keterangan') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'm_kota_ktp.keterangan') || '-',
          update: this.keyBiodataUpdates.includes('k_kota_ktp'),
        },
        {
          label: 'Alamat (tempat tinggal sekarang)',
          lama: this.$getDeepObj(this.biodata, 'alamat') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'alamat') || '-',
          update: this.keyBiodataUpdates.includes('alamat'),
        },
        {
          label: 'Provinsi (tempat tinggal sekarang)',
          lama: this.$getDeepObj(this.biodata, 'm_propinsi.keterangan') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'm_propinsi.keterangan') || '-',
          update: this.keyBiodataUpdates.includes('k_propinsi'),
        },
        {
          label: 'Kabupaten/Kota (tempat tinggal sekarang)',
          lama: this.$getDeepObj(this.biodata, 'm_kota.keterangan') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'm_kota.keterangan') || '-',
          update: this.keyBiodataUpdates.includes('k_kota'),
        },
        {
          label: 'Kode Pos',
          lama: this.$getDeepObj(this.biodata, 'kodepos') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'kodepos') || '-',
          update: this.keyBiodataUpdates.includes('kodepos'),
        },
        {
          label: 'No Telepon (HP)',
          lama: this.$getDeepObj(this.biodata, 'no_hp') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'no_hp') || '-',
          update: this.keyBiodataUpdates.includes('no_hp'),
        },
        {
          label: 'No Telepon (HP - WhatsApp)',
          lama: this.$getDeepObj(this.biodata, 'no_wa') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'no_wa') || '-',
          update: this.keyBiodataUpdates.includes('no_wa'),
        },
        {
          label: 'No HP prabayar (aktif)',
          lama: this.$getDeepObj(this.biodata, 'no_hp_prabayar') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'no_hp_prabayar') || '-',
          update: this.keyBiodataUpdates.includes('no_hp_prabayar'),
        },
        {
          label: 'Nama pemilik No HP Prabayar (aktif)',
          lama: this.$getDeepObj(this.biodata, 'nama_prabayar') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'nama_prabayar') || '-',
          update: this.keyBiodataUpdates.includes('nama_prabayar'),
        },
        {
          label: 'Email (untuk kontak)',
          lama: this.$getDeepObj(this.biodata, 'email') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'email') || '-',
          update: this.keyBiodataUpdates.includes('email'),
        },
        {
          label: 'Akun belajar.id dari UPT',
          lama: this.$getDeepObj(this.biodata, 'akun_belajar_upt') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'akun_belajar_upt') || '-',
          update: this.keyBiodataUpdates.includes('akun_belajar_upt'),
        },
        {
          label: 'Pendidikan Terakhir',
          lama: this.$getDeepObj(this.biodata, 'm_kualifikasi.keterangan') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'm_kualifikasi.keterangan') || '-',
          update: this.keyBiodataUpdates.includes('k_kualifikasi'),
        },
        {
          label: 'Jurusan',
          lama: this.$getDeepObj(this.biodata, 'pendidikan_jurusan') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'pendidikan_jurusan') || '-',
          update: this.keyBiodataUpdates.includes('pendidikan_jurusan'),
        },
        {
          label: 'Bidang Pendidikan Terakhir',
          lama: this.$getDeepObj(this.biodata, 'm_profil_opsi_psp_pendidikan_bidang.keterangan') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'm_profil_opsi_psp_pendidikan_bidang.keterangan') || '-',
          update: this.keyBiodataUpdates.includes('k_pendidikan_bidang_psp'),
        },
        {
          label: 'Nama Instansi Pendidikan Terakhir',
          lama: this.$getDeepObj(this.biodata, 'pendidikan_instansi') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'pendidikan_instansi') || '-',
          update: this.keyBiodataUpdates.includes('pendidikan_instansi'),
        },
        {
          label: 'Pengalaman melakukan pendampingan peningkatan mutu pendidikan (pengalaman bersifat akumulasi)',
          lama: this.$getDeepObj(this.biodata, 'm_profil_opsi_psp_pendampingan.keterangan') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'm_profil_opsi_psp_pendampingan.keterangan') || '-',
          update: this.keyBiodataUpdates.includes('k_pendampingan_psp'),
        },
        {
          label: 'Pengalaman melakukan pendampingan peningkatan mutu pendidikan (pengalaman bersifat akumulasi)',
          lama: this.$getDeepObj(this.biodata, 'm_unsur_psp.keterangan') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'm_unsur_psp.keterangan') || '-',
          update: this.keyBiodataUpdates.includes('k_unsur_psp'),
        },
        {
          label: 'Profesi/Pekerjaan saat ini',
          lama: this.$getDeepObj(this.biodata, 'profesi') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'profesi') || '-',
          update: this.keyBiodataUpdates.includes('profesi'),
        },
      ];

      return items.filter((item) => item.update);
    },

    profilInstansi() {
      const items = [
        {
          label: 'Apakah instansi Anda saat ini berubah dari yang ada di CV saat pendaftaran?',
          lama:
            this.biodata.k_beda_instansi_psp === null
              ? '-'
              : this.mBedaInstansi[this.biodata.k_beda_instansi_psp] || '-',
          baru:
            this.biodataEdit.k_beda_instansi_psp === null
              ? '-'
              : this.mBedaInstansi[this.biodataEdit.k_beda_instansi_psp] || '-',
          update: this.keyBiodataUpdates.includes('k_beda_instansi_psp'),
        },
        {
          label: 'Nama Instansi',
          lama: this.$getDeepObj(this.biodata, 'instansi_nama') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'instansi_nama') || '-',
          update: this.keyBiodataUpdates.includes('instansi_nama'),
        },
        {
          label: 'Alamat Instansi',
          lama: this.$getDeepObj(this.biodata, 'instansi_alamat') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'instansi_alamat') || '-',
          update: this.keyBiodataUpdates.includes('instansi_alamat'),
        },
        {
          label: 'Provinsi Instansi',
          lama: this.$getDeepObj(this.biodata, 'm_propinsi_instansi.keterangan') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'm_propinsi_instansi.keterangan') || '-',
          update: this.keyBiodataUpdates.includes('instansi_k_propinsi'),
        },
        {
          label: 'Kabupaten/Kota Instansi',
          lama: this.$getDeepObj(this.biodata, 'm_kota_instansi.keterangan') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'm_kota_instansi.keterangan') || '-',
          update: this.keyBiodataUpdates.includes('instansi_k_kota'),
        },
        {
          label: 'Website Instansi',
          lama: this.$getDeepObj(this.biodata, 'instansi_situs') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'instansi_situs') || '-',
          update: this.keyBiodataUpdates.includes('instansi_situs'),
        },
        {
          label: 'Apakah instansi Saat Ini sama dengan Instansi Induk Anda?',
          lama: this.biodata.k_beda_tugas_psp === null ? '-' : this.mBedaTugas[this.biodata.k_beda_tugas_psp] || '-',
          baru:
            this.biodataEdit.k_beda_tugas_psp === null
              ? '-'
              : this.mBedaTugas[this.biodataEdit.k_beda_tugas_psp] || '-',
          update: this.keyBiodataUpdates.includes('k_beda_tugas_psp'),
        },
        {
          label: 'Nama Instansi',
          lama: this.$getDeepObj(this.biodata, 'tugas_nama') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'tugas_nama') || '-',
          update: this.keyBiodataUpdates.includes('tugas_nama'),
        },
        {
          label: 'Alamat Instansi',
          lama: this.$getDeepObj(this.biodata, 'tugas_alamat') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'tugas_alamat') || '-',
          update: this.keyBiodataUpdates.includes('tugas_alamat'),
        },
        {
          label: 'Provinsi Instansi',
          lama: this.$getDeepObj(this.biodata, 'm_propinsi_tugas.keterangan') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'm_propinsi_tugas.keterangan') || '-',
          update: this.keyBiodataUpdates.includes('k_propinsi_tugas'),
        },
        {
          label: 'Kabupaten/Kota Instansi',
          lama: this.$getDeepObj(this.biodata, 'm_kota_tugas.keterangan') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'm_kota_tugas.keterangan') || '-',
          update: this.keyBiodataUpdates.includes('k_kota_tugas'),
        },
        {
          label: 'Website Instansi',
          lama: this.$getDeepObj(this.biodata, 'tugas_situs') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'tugas_situs') || '-',
          update: this.keyBiodataUpdates.includes('tugas_situs'),
        },
      ];

      return items.filter((item) => item.update);
    },

    profilPenugasan() {
      const items = [
        {
          label: 'Jenjang dan Jumlah Satuan Pendidikan Penugasan sebagai FSP',
          lama: this.$fkata(this.aktifs) || '-',
          baru: this.$fkata(this.aktifsEdit) || '-',
          update: this.tugasEdit['aktif'],
        },
        {
          label: 'Jenjang dan Jumlah Satuan Pendidikan Penugasan sebagai FSP',
          lama: this.$fkata(this.lamas) || '-',
          baru: this.$fkata(this.lamasEdit) || '-',
          update: this.tugasEdit['selesai'],
        },
        {
          label: 'Jenjang dan Jumlah Satuan Pendidikan Penugasan sebagai FSP',
          lama: this.rencanas.join('<br>'),
          baru: this.rencanasEdit.join('<br>'),
          update: this.tugasEdit['rencana'],
        },
      ];

      return items.filter((item) => item.update);
    },

    profilAdministrasi() {
      const items = [
        {
          label: 'Alamat (sesuai KTP)',
          lama: this.$getDeepObj(this.biodata, 'm_profil_opsi_psp_pegawai.keterangan') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'm_profil_opsi_psp_pegawai.keterangan') || '-',
          update: this.keyBiodataUpdates.includes('k_pegawai_psp'),
        },
        {
          label: 'NIP',
          lama: this.$getDeepObj(this.biodata, 'nip') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'nip') || '-',
          update: this.keyBiodataUpdates.includes('nip'),
        },
        {
          label: 'Pangkat / Golongan',
          lama: this.$getDeepObj(this.biodata, 'm_golongan.keterangan') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'm_golongan.keterangan') || '-',
          update: this.keyBiodataUpdates.includes('k_golongan'),
        },
        {
          label: 'NPWP',
          lama: this.$getDeepObj(this.biodata, 'npwp') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'npwp') || '-',
          update: this.keyBiodataUpdates.includes('npwp'),
        },
        {
          label: 'Nama Bank dan Cabang Bank',
          lama:
            this.biodata.rekening_bank && this.biodata.rekening_cabang
              ? `${this.biodata.rekening_bank} - ${this.biodata.rekening_cabang}`
              : '-',
          baru:
            this.biodataEdit.rekening_bank && this.biodataEdit.rekening_cabang
              ? `${this.biodataEdit.rekening_bank} - ${this.biodataEdit.rekening_cabang}`
              : '-',
          update: this.keyBiodataUpdates.includes('rekening_bank') || this.keyBiodataUpdates.includes('cabang_bank'),
        },
        {
          label: 'Nomor rekening',
          lama: this.$getDeepObj(this.biodata, 'rekening_nomor') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'rekening_nomor') || '-',
          update: this.keyBiodataUpdates.includes('rekening_nomor'),
        },
        {
          label: 'Nomor rekening',
          lama: this.$getDeepObj(this.biodata, 'rekening_nomor') || '-',
          baru: this.$getDeepObj(this.biodataEdit, 'rekening_nomor') || '-',
          update: this.keyBiodataUpdates.includes('rekening_nomor'),
        },
      ];

      return items.filter((item) => item.update);
    },

    profilBerkas() {
      const items = [
        {
          label: 'Ijazah Pendidikan Terakhir',
          file_lama: this.$getDeepObj(this.berkases, 'ijazah.file'),
          url_lama: this.$getDeepObj(this.berkases, 'ijazah.url'),
          file_baru: this.$getDeepObj(this.berkasesEdit, 'ijazah.file'),
          url_baru: this.$getDeepObj(this.berkasesEdit, 'ijazah.url'),
          update: this.keyBerkasUpdates.includes(this.$getDeepObj(this.berkasesEdit, 'ijazah.id')),
        },
        {
          label: 'Transkrip Nilai Pendidikan Terakhir',
          file_lama: this.$getDeepObj(this.berkases, 'transkrip.file'),
          url_lama: this.$getDeepObj(this.berkases, 'transkrip.url'),
          file_baru: this.$getDeepObj(this.berkasesEdit, 'transkrip.file'),
          url_baru: this.$getDeepObj(this.berkasesEdit, 'transkrip.url'),
          update: this.keyBerkasUpdates.includes(this.$getDeepObj(this.berkasesEdit, 'transkrip.id')),
        },
        {
          label: 'Surat Izin Atasan',
          file_lama: this.$getDeepObj(this.berkases, 'rekomendasi.file'),
          url_lama: this.$getDeepObj(this.berkases, 'rekomendasi.url'),
          file_baru: this.$getDeepObj(this.berkasesEdit, 'rekomendasi.file'),
          url_baru: this.$getDeepObj(this.berkasesEdit, 'rekomendasi.url'),
          update: this.keyBerkasUpdates.includes(this.$getDeepObj(this.berkasesEdit, 'rekomendasi.id')),
        },
        {
          label: 'SK Penempatan / SK Jabatan Terakhir Instansi Induk',
          file_lama: this.$getDeepObj(this.berkases, 'tugas.file'),
          url_lama: this.$getDeepObj(this.berkases, 'tugas.url'),
          file_baru: this.$getDeepObj(this.berkasesEdit, 'tugas.file'),
          url_baru: this.$getDeepObj(this.berkasesEdit, 'tugas.url'),
          update: this.keyBerkasUpdates.includes(this.$getDeepObj(this.berkasesEdit, 'tugas.id')),
        },
        {
          label: 'NPWP',
          file_lama: this.$getDeepObj(this.berkases, 'npwp.file'),
          url_lama: this.$getDeepObj(this.berkases, 'npwp.url'),
          file_baru: this.$getDeepObj(this.berkasesEdit, 'npwp.file'),
          url_baru: this.$getDeepObj(this.berkasesEdit, 'npwp.url'),
          update: this.keyBerkasUpdates.includes(this.$getDeepObj(this.berkasesEdit, 'npwp.id')),
        },
        {
          label: 'Buku Rekening',
          file_lama: this.$getDeepObj(this.berkases, 'rekening.file'),
          url_lama: this.$getDeepObj(this.berkases, 'rekening.url'),
          file_baru: this.$getDeepObj(this.berkasesEdit, 'rekening.file'),
          url_baru: this.$getDeepObj(this.berkasesEdit, 'rekening.url'),
          update: this.keyBerkasUpdates.includes(this.$getDeepObj(this.berkasesEdit, 'rekening.id')),
        },
      ];

      return items.filter((item) => item.update);
    },

    rekaps() {
      return [
        {
          judul: 'Biodata Diri',
          hidden: !this.profilBiodata.length,
          items: this.profilBiodata,
        },
        {
          judul: 'Data Instansi',
          hidden: !this.profilInstansi.length,
          items: this.profilInstansi,
        },
        {
          judul: 'Referensi Penugasan FSP',
          hidden: !this.profilPenugasan.length,
          items: this.profilPenugasan,
        },
        {
          judul: 'Data Pendukung Administrasi',
          hidden: !this.profilAdministrasi.length,
          items: this.profilAdministrasi,
        },
        {
          judul: 'Dokumen Pendukung',
          hidden: !this.profilBerkas.length,
          items: this.profilBerkas,
        },
      ];
    },
  },
  methods: {
    open(mode = 'info') {
      this.mode = mode;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    approve() {
      this.$emit('approve', this.mode);
    },
  },
};
</script>
